import { render } from "./employe-card.vue?vue&type=template&id=2725a4ea"
import script from "./employe-card.vue?vue&type=script&lang=js"
export * from "./employe-card.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__